import { render, staticRenderFns } from "./Printouts.vue?vue&type=template&id=35d0b557&scoped=true"
import script from "./Printouts.vue?vue&type=script&lang=js"
export * from "./Printouts.vue?vue&type=script&lang=js"
import style0 from "./Printouts.vue?vue&type=style&index=0&id=35d0b557&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d0b557",
  null
  
)

export default component.exports